module.exports = __webpack_public_path__ + "static/media/gamla-uppsala-kyrka.a14c93b3.svg";